import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IUnmanagedBusinessAutoRegisterSettingRepository } from '@/coreInfrastructureModule/interfaces/IUnmanagedBusinessAutoRegisterSettingRepository';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';
import { UnmanagedBusinessAutoRegisterSettingAdapter } from '../adapters/unmanagedBusinessAutoRegisterSettingAdapter';
import { UnmanagedBusinessAutoRegisterSettingEntity } from '../domains/entities/unmanagedBusinessAutoRegisterSetting';

/**
 * 未管理取引の自動登録設定を取得するUseCase
 */
export class GetUnmanagedBusinessAutoRegisterSettingUseCase {
  /**
   * コンストラクタ
   * @param repository - 未管理取引の自動登録設定を取得するRepository
   */
  constructor(private readonly repository: IUnmanagedBusinessAutoRegisterSettingRepository) {}

  /**
   * 設定を取得する
   */
  public Execute = async (): Promise<INetworkResult<UnmanagedBusinessAutoRegisterSettingEntity, IError>> => {
    const result = await this.repository.get();
    if (result.status.type === 'success') {
      return {
        status: {
          type: 'success',
          data: UnmanagedBusinessAutoRegisterSettingAdapter.toEntity(result.status.data),
        },
      };
    }

    return { status: result.status };
  };
}
